import React, { Component } from 'react';
import { Modal, Header, Button, Form as Forms, Grid, Icon, Table } from 'semantic-ui-react'
import { Formik, Field, Form } from 'formik';
import CreateAxios from '../axiosComponent/createAxios'
import ReadAxios from '../axiosComponent/readAxios'
import * as Yup from 'yup';
import CityNameComponent from '../customerComponent/cityNameComponent'
import cogoToast from 'cogo-toast';
export default class RejectModal extends Component {

    state = {
        editing: false,
        open: false,
        branch_data: this.props.data,
        transporterMasterId: this.props.Masterid,
        stateItems: []
    }


    componentDidMount() {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/stateMaster`, method: "get",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    stateItems: res.data.resultSet
                })
            }
        })
    }

    rejectTransporter() {
        CreateAxios({
            approveURL: `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/reject/` + this.props.MasterId
        }).then((res) => {
            if (res.status === 200) {
                let alert = {
                    type: "success",
                    messageHeader: "Success",
                    messageBody: res.data.message,
                };
                this.setState({ open: false })
                console.log("successfully rejected")
                cogoToast.success("Partner Rejected")
                window.location.reload();
            }
        }).catch((err) => {
            let alert = {
                type: "error",
                messageHeader: "Error",
                messageBody: err.data,
            };
            let error_msg = err.response ? err.response.data.message : err.message
            cogoToast.error(error_msg)
            console.log(err);
        });

    }

    getStateName = (state_id) => {
        return this.state.stateItems.map((o, i) => {
            const { state, stateId } = o
            if (stateId == state_id) {
                return (
                    state
                )
            }
        })
    }

    renderBranchData() {
        return this.props.data.map((o, i) => {
            const { vendorBranchName, vendorBranchStateId, vendorBranchPAN, vendorBranchGST, vendorBranchAddress, vendorBranchCity, vendorBranchBranchPincode } = o
            return (
                <Table.Row key={i}>
                    <Table.Cell>{vendorBranchName}</Table.Cell>
                    <Table.Cell>{this.getStateName(vendorBranchStateId)}</Table.Cell>
                    <Table.Cell>{vendorBranchPAN}</Table.Cell>
                    <Table.Cell>{vendorBranchGST}</Table.Cell>
                    <Table.Cell>{vendorBranchAddress}</Table.Cell>
                    <Table.Cell>
                        <CityNameComponent
                            cityId={vendorBranchCity}
                        />
                    </Table.Cell>
                    <Table.Cell>{vendorBranchBranchPincode}</Table.Cell>
                </Table.Row>
            )
        })
    }

    render() {

        // console.log(this.props.MasterId)
        return (
            <div>
                <Modal
                    size="large"
                    /*eslint-disable*/
                    onClose={() => this.setState({ open: false })}
                    onOpen={() => this.setState({ open: true })}
                    open={this.state.open}
                    trigger={<Button type="button" hidden={this.props.hidden} size="mini" color="red" className="w3-text-white" icon>Reject</Button>}
                >
                    <Header><h5>Reject Partner</h5></Header>
                    {this.props.data.length > 0 ?
                        <Modal.Content>
                            <Modal.Description>
                                <Table striped>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Branch</Table.HeaderCell>
                                            <Table.HeaderCell>State</Table.HeaderCell>
                                            <Table.HeaderCell>PAN Number</Table.HeaderCell>
                                            <Table.HeaderCell>GST Number</Table.HeaderCell>
                                            <Table.HeaderCell>Address</Table.HeaderCell>
                                            <Table.HeaderCell>City</Table.HeaderCell>
                                            <Table.HeaderCell>Pincode</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {this.renderBranchData()}
                                    </Table.Body>
                                </Table>
                            </Modal.Description>
                        </Modal.Content>
                        : ""}
                    <Modal.Actions>
                        <Button size="mini" color='blue' onClick={() => this.setState({ open: false })}>
                            <Icon name='remove' /> Close
                        </Button>
                        <Button size="mini" color='red' onClick={() => this.rejectTransporter()}>
                            <Icon name='trash' /> Reject
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );

    }
}